<div class="ehe-info-modal">
	<button class="ehe-info-modal__close" mat-dialog-close aria-label="Close">
		<svg
			width="18"
			height="18"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			stroke-width="2.5"
			stroke-linecap="round"
			stroke-linejoin="round">
			<line x1="18" y1="6" x2="6" y2="18"></line>
			<line x1="6" y1="6" x2="18" y2="18"></line>
		</svg>
	</button>

	<div class="ehe-info-modal__icon" [ngClass]="'ehe-info-modal__icon--' + data.type">
		<svg
			*ngIf="data.type === 'success'"
			width="28"
			height="28"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			stroke-width="2.5"
			stroke-linecap="round"
			stroke-linejoin="round">
			<polyline points="20 6 9 17 4 12"></polyline>
		</svg>
		<svg
			*ngIf="data.type === 'warning'"
			width="28"
			height="28"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			stroke-width="2.5"
			stroke-linecap="round"
			stroke-linejoin="round">
			<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
			<line x1="12" y1="9" x2="12" y2="13"></line>
			<line x1="12" y1="17" x2="12.01" y2="17"></line>
		</svg>
		<svg
			*ngIf="data.type !== 'success' && data.type !== 'warning'"
			width="28"
			height="28"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			stroke-width="2.5"
			stroke-linecap="round"
			stroke-linejoin="round">
			<circle cx="12" cy="12" r="10"></circle>
			<line x1="12" y1="8" x2="12" y2="12"></line>
			<line x1="12" y1="16" x2="12.01" y2="16"></line>
		</svg>
	</div>

	<h2 class="ehe-info-modal__title" *ngIf="data.title">{{ data.title }}</h2>

	<p class="ehe-info-modal__message" [innerHTML]="data.message"></p>

	<div class="ehe-info-modal__actions">
		<button class="ehe-info-modal__btn" *ngIf="isButtonActive('OKAY')" (click)="ok()" mat-dialog-close>OK</button>
		<div class="ehe-info-modal__yesno" *ngIf="isButtonActive('YESNO')">
			<button class="ehe-info-modal__btn ehe-info-modal__btn--outline" (click)="no()" mat-dialog-close>No</button>
			<button class="ehe-info-modal__btn" (click)="yes()" mat-dialog-close>Yes</button>
		</div>
		<div *ngIf="isButtonActive('RESCHEDULE')">
			<button class="ehe-info-modal__btn" mat-button appEheAnalytics (click)="reschedule()">
				<span [translate]="'scheduling.appointment-cancellation.reschedule-button'">Reschedule Appointment</span>
			</button>
		</div>
	</div>
</div>
